import { Button } from '@savvy-kit/components/button';
import { X } from 'lucide-react';

export type FilterActionsProps = {
  readonly onApply?: () => void;
  readonly onClear: () => void;
};

/**
 * Shared action buttons (Apply/Clear) used across all filter components.
 * Provides consistent styling and behavior for filter actions.
 */
export function FilterActions({ onApply, onClear }: FilterActionsProps) {
  return (
    <div className="flex items-center justify-between gap-2">
      <Button type="button" variant="ghost" size="sm" onClick={onClear}>
        <X className="mr-1 h-3 w-3" />
        Clear
      </Button>
      {onApply && (
        <Button type="button" size="sm" onClick={onApply}>
          Apply
        </Button>
      )}
    </div>
  );
}
